export default {
    bind(el) {
        el.addEventListener("click", () => {
            console.log("Directive");
            document.body.classList.toggle("sa-body-sidebar-open");
            // document.body.classList.toggle('sidebar-open');
        });
    },
};
